import styled from 'styled-components/macro';
import { Spin } from 'antd';

export const Spinner = styled(Spin)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
